<template>
	<v-container fluid>
		<div v-if="!loading">
			<!--table-->
			<!--table head-->
			<v-row class="mt-8 total" no-gutters>
				<v-col class="tabCell text-left">Project</v-col>
				<v-col v-for="item in headers"
					class="tabCell"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<!--table content-->
			<v-row v-for="(project, index) in allProjects" :key="index" no-gutters>
				<v-col class="tabCell text-left">{{project.name}}</v-col>
				<v-col class="tabCell">{{ cost(project) }}</v-col>
				<v-col class="tabCell">{{ project.effect }}</v-col>
				<v-col v-if="hired(project)" class="tabCell">
					<v-btn color="#1A237E" text small
						class="text-lowercase"
						@click="deleteProject(project)"
						>suspend
					</v-btn>
				</v-col>
				<v-col v-else class="tabCell">
					<v-btn color="#1A237E" text small
						class="text-lowercase" 
						@click="addProject(project)">hire
					</v-btn>
				</v-col>				
			</v-row>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
import numeral from 'numeral'
import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				headers: ['Budget', 'Effect', 'Decision']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			allProjects () {
				return this.$store.getters.allProjects
			},
			projects () {
				return this.$store.getters.projects
			}
		},
		methods: {
			hired (project) {
				const hired = this.projects.find(pro => pro.name === project.name)
				return Boolean(hired)
			},
			cost (project) {
				return numeral(project.cost).format('0,0[.]0')
			},
			async addProject (project) {
				//console.log(project)
				project.company = this.company
				const obj = {
					gameId: this.gameId,
					round: this.round,
					project: project
				}
				try {
					await this.$store.dispatch('addProject', obj)		
					}
				catch (error) {
					this.error
				}
			},
			async deleteProject(project) {
				const suspended = this.projects.find(pro => pro.name === project.name)
				if (suspended) {
					const obj = {
						gameId: this.gameId,
						round: this.round,
						id: suspended.id
					}
					try {
						await this.$store.dispatch('deleteProject', obj)		
						}
					catch (error) {
						throw error
					}
				}
			}
		},
		components: { Loader}
	}
</script>
